'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'cactus';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f8a7';
var svgPathData = 'M446.54 208.78C419 213.32 400 239.24 400 267.15V296a8 8 0 0 1-8 8h-40V101.43c0-52-38.93-98.58-90.84-101.29A96 96 0 0 0 160 96v96h-40a8 8 0 0 1-8-8v-28.85c0-27.91-19-53.83-46.54-58.37A56.08 56.08 0 0 0 0 152v32a120 120 0 0 0 120 120h40v192a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-80h40a120 120 0 0 0 120-120v-32a56.08 56.08 0 0 0-65.46-55.22zM160 272h-40a88.09 88.09 0 0 1-88-88v-32a24 24 0 0 1 48 0v32a40 40 0 0 0 40 40h40zm160 208H192V96a64 64 0 0 1 128 0zm160-184a88.09 88.09 0 0 1-88 88h-40v-48h40a40 40 0 0 0 40-40v-32a24 24 0 0 1 48 0zM240 128a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm32 224a16 16 0 1 0 16 16 16 16 0 0 0-16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faCactus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;